export const isDev = () =>
  !import.meta.env.NODE_ENV || import.meta.env.NODE_ENV === "development";
